<div id="gcc" class="page-login">
  <gcc-header
    *ngIf="
      router.url.split('?')[0] !== '/pedidoImpressao' &&
      router.url.split('?')[0] !== '/login'
    "
  ></gcc-header>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
  <app-cookie-banner (closed)="onCookieBannerClose()"></app-cookie-banner>
  <gcc-footer
    *ngIf="
      router.url.split('?')[0] !== '/pedidoImpressao' &&
      router.url.split('?')[0] !== '/login'
    "
  ></gcc-footer>
</div>
